<template>
  <!-- 导出年度分析报告 -->
  <div class="analysisReport">
    <div class="analysisReport_box" id="pdfPrint">
      <div class="header_titles">
        <h1>职业教育“{{header.zykName}}”专业教学资源库({{header.zykNum}})</h1>
        <h1 style="margin-top: 18px;">{{yearMonthText}}</h1>
        <div class="number_time">
          <div>
            <span>主持单位：{{header.allHostUnit}}</span>
            <span>分析时间：{{header.startTime}} 至 {{header.endTime}}</span>
          </div>
          <p></p>
          <p></p>
        </div>
      </div>
      <div class="division" style="margin:50px 0px">
        <span>1. 当前资源库总体情况</span>
      </div>

      <div class="chart_box">
        <h4>1.1 当前资源库用户情况</h4>
        <p> 当前该资源库的用户数（教师和学生总数）{{resourceLibrary.total}}人，
          其中学生{{resourceLibrary.studentNum}}人，
          占比{{resourceLibrary.studentProportion}}；
          教师{{resourceLibrary.teacherNum}}人，
          占比{{resourceLibrary.tearcherProportion}}；
          具体如图 1 所示。</p>
        <div class="standards_content echartsHeight">
          <circularChart :isShowTextColor="true" :refId="'resourceLibraryChart'" :datas='resourceLibrary.dataList' :colorName='5' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
        </div>
        <div class="chart_name">图1 资源库注册用户类型分布情况</div>
      </div>

      <div class="chart_box">
        <h4>1.2 当前资源库资源、课程情况</h4>
        <p> 当前该资源库的素材资源总数{{typeDistribution.total}}条，其中各类型素材资源占比如图2 所示。</p>

        <div class="standards_content echartsHeight">
          <circularChart :isShowTextColor="true" :refId="'typeDistributionChart'" :datas='typeDistribution.dataList' :colorName='4' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
        </div>
        <div class="chart_name">图2 资源库素材资源类型分布</div>
      </div>

      <!-- 当前该资源库建有标准化课程 -->
      <div class="chart_box">
        <p> 当前该资源库建有标准化课程{{totalNum}}门。</p>
        <p style="margin-top: 50px;">（注1：标准化课程指资源库建设团队按照《指南》要求建设和提供的，涵盖课程基本知识点和技能点，能够适应 全国同类和相近专业在线教学基本需要的结构化课程。标准化课程的正确性、逻辑性、权威性由资源库建设团队保 证。个性化课程指教师在使用资源库过程中，结合自身实际教学需要和学生特点，对标准化课程进行改造、补充、 重构后形成的个性化课程。个性化课程的正确性、逻辑性由建课教师自行保障。注2：如标准化课程或个性化课程 显示为0，表明该资源库在课程标注上不规范，需要在资源库运行平台中对课程分类重新标注。）
        </p>
      </div>

      <div class="chart_box" style="margin-top: 300px;margin-bottom: 0px;">
        <h4>1.3 资源库综合排名情况</h4>
        <p v-if="top.zykRank <= 188">
          当前，该资源库建设单位已实名但无活动用户数（教师和学生总数）{{ top.noStudentAndTearch}}人；该资源库无活动资源{{top.noActiveResource}}条。
          根据资源库开展应用情况，取全年访问量、上述无活动用户数、上述无活动资源数等多项指标进行综合排名，本资源库在203个国家级专业教学资源库中排名第{{top.zykRank}}名，请继续深入推广应用。
        </p>
        <p v-if="top.zykRank > 188">
          当前，该资源库建设单位已实名但无活动用户数（教师和学生总数）{{ top.noStudentAndTearch}}人；该资源库无活动资源{{top.noActiveResource}}条。
          根据资源库开展应用情况，取全年访问量、上述无活动用户数、上述无活动资源数等多项指标进行综合排名，本资源库在203个国家级专业教学资源库中排名属于后15名，请加大资源库的推广应用力度。
        </p>
      </div>

      <div class="division" style="margin-top: 100px;">
        <span>2. 2022年资源库新增情况</span>
      </div>

      <div class="chart_box">
        <h4>2.1 用户新增情况</h4>
        <p> 该资源库新增教师用户数{{usersMonth.teacherNum}}人，新增学生用户数{{usersMonth.studentNum}}人，具体新增情况如图 3 所示。</p>
        <div class="standards_content echartsHeight">
          <discountChart :refId="'usersMonthChart'" :datas='usersMonth.dataList' :transverseData='usersMonth.transverseData' :colorList='usersMonth.colorList' :legendList="usersMonth.legendList" :innerText="'单位：人'" :isShowTextColor="true" :isExportTextColor="true"></discountChart>
        </div>
        <div class="chart_name">图3 用户新增情况</div>
      </div>

      <div class="chart_box" style="margin-top: 340px;">
        <h4>2.2 素材资源新增情况</h4>
        <p> 该资源库新增素材资源{{resourcesMonth.total}}条，具体新增情况如图 4 所示。</p>
        <div class="standards_content echartsHeight">
          <vcolumnarChart :refId="'resourcesMonthChart'" :legendList="resourcesMonth.legendList" :datas='resourcesMonth.dataList' :transverseData='resourcesMonth.transverseData' :colorList="resourcesMonth.colorList" :colorName='1' :innerText="'单位：条'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80" :isShowTextColor="true" :isExportTextColor="true"></vcolumnarChart>
        </div>
        <div class="chart_name">图4 资源新增情况</div>
      </div>

      <div class="chart_box" style="margin-top: 340px;">
        <h4>2.3 课程新增情况</h4>
        <!-- <p>该资源库新增课程数<span v-for="(item,index) in coursesMonth.dataList" :key="index">{{item.name}}新增{{item.value}}门，</span>具体新增情况如图 5 所示。</p> -->
        <p>该资源库新增课程数(标准化和个性化课程总和){{coursesMonth.total}}门，具体新增情况如图 5 所示。</p>
        <div class="standards_content echartsHeight">
          <vcolumnarChart :refId="'lastcoursesMonthChart'" :legendList="coursesMonth.legendList" :datas='coursesMonth.dataList' :transverseData='coursesMonth.transverseData' :colorList="coursesMonth.colorList" :colorName='1' :innerText="'单位：门'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80" :isShowTextColor="true" :isExportTextColor="true"></vcolumnarChart>
        </div>
        <div class="chart_name divorced">图5 课程新增情况</div>
      </div>

      <div class="division">
        <span style="margin-top: 50px;">3. 2022年资源库应用情况</span>
      </div>

      <div class="chart_box" style="margin-top: 160px;">
        <h4>3.1 资源访问情况</h4>
        <p> 该资源库资源访问数{{accessMonth.total>10000?(accessMonth.total / 10000).toFixed(2) + '万':accessMonth.total}}次，具体访问情况如图 6 所示。</p>
        <div class="standards_content echartsHeight">
          <discountChart :refId="'accessMonthChart'" :datas='accessMonth.dataList' :transverseData='accessMonth.transverseData' :colorList='accessMonth.colorList' :legendList="accessMonth.legendList" :innerText="'单位：次'" :isShowTextColor="true" :isExportTextColor="true"></discountChart>
        </div>
        <div class="chart_name">图6 资源访问情况</div>
      </div>

      <div class="chart_box" style="margin-top: 100px;">
        <h4>3.2 课程访问情况</h4>
        <p> 该资源库课程访问数{{visitsMonth.total>10000?(visitsMonth.total / 10000).toFixed(2) + '万':visitsMonth.total}}次，具体访问情况如图 7 所示。</p>
        <div class="standards_content echartsHeight">
          <discountChart :refId="'visitsMonthChart'" :datas='visitsMonth.dataList' :transverseData='visitsMonth.transverseData' :colorList='visitsMonth.colorList' :legendList="visitsMonth.legendList" :innerText="'单位：次'" :isShowTextColor="true" :isExportTextColor="true"></discountChart>
        </div>
        <div class="chart_name">图7 课程访问情况</div>
      </div>

      <div class="chart_box" style="margin-top: 260px;">
        <h4>3.3 用户访问情况</h4>
        <p> 该资源库用户访问数{{userAccessMonth.total>100000000?(userAccessMonth.total  / 100000000).toFixed(2) + '亿':userAccessMonth.total>10000?(userAccessMonth.total / 10000).toFixed(2) + '万':userAccessMonth.total}}人次，具体访问情况如图 8 所示。</p>
        <div class="standards_content echartsHeight">
          <discountChart :refId="'userAccessMonthChart'" :datas='userAccessMonth.dataList' :transverseData='userAccessMonth.transverseData' :colorList='userAccessMonth.colorList' :legendList="userAccessMonth.legendList" :innerText="'单位：次'" :isShowTextColor="true" :isExportTextColor="true"></discountChart>
        </div>
        <div class="chart_name">图8 用户访问情况</div>
      </div>

      <div class="chart_box" style="margin-top: 50px;">
        <h4>3.4 访问量较多的教师</h4>
        <div class="biaoge">
          <table border="1" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
            <tr>
              <th>排名</th>
              <th>姓名</th>
              <th>所属院校</th>
              <th>访问量</th>
            </tr>

            <tr v-for="(item,index) in tearcherList.dataList" :key="index" v-show="tearcherList.dataList.length > 0">
              <td>{{index+1}}</td>
              <td>{{item.author}}</td>
              <td>{{item.school}}</td>
              <td>{{parseInt(item.num)}}</td>
            </tr>
            <tr v-show="tearcherList.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
        <div class="chart_name" style="margin-top: 240px;">图9 访问量较多的教师（前10名）</div>
      </div>

      <div class="chart_box" style="margin-top: 50px;">
        <h4>3.5 访问量较多的学生</h4>
        <div class="biaoge">
          <table border="1" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
            <tr>
              <th>排名</th>
              <th>姓名</th>
              <th>所属院校</th>
              <th>访问量</th>
            </tr>

            <tr v-for="(item,index) in studentList.dataList" :key="index" v-show="studentList.dataList.length > 0">
              <td>{{index+1}}</td>
              <td>{{item.author}}</td>
              <td>{{item.school}}</td>
              <td>{{parseInt(item.num)}}</td>
            </tr>
            <tr v-show="studentList.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
        <div class="chart_name" style="margin-top: 240px;">图10 访问量较多的学生（前10名）</div>
      </div>

      <div class="division" style="margin-top: 200px;">
        <span style="margin-top: 130px;width: 815px;">4. 2021年和2022年建设与应用数据对比分析</span>
      </div>

      <div class="chart_box" style="margin-top: 220px;">
        <h4>4.1 资源总数对比分析</h4>
        <div class="standards_content echartsHeight">
          <vcolumnarChartColor :isShowTextColor="true" :isExportTextColor="true" :refId="'participatingChart'" :datas='zykTotal.dataList' :transverseData="zykTotal.transverseData" :colorList="zykTotal.colorList" :legendList="zykTotal.legendList" :innerText="'单位：条'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></vcolumnarChartColor>
        </div>
        <div class="chart_name">图11 2021年资源库资源总数与2022年资源库资源总数对比分析</div>
      </div>

      <div class="chart_box" style="margin-top: 120px;">
        <h4>4.2 课程总数对比分析</h4>
        <div class="standards_content echartsHeight">
          <vcolumnarChart :isShowTextColor="true" :isExportTextColor="true" :refId="'participatingChart'" :datas='courseTotal.dataList' :transverseData="courseTotal.transverseData" :colorList="courseTotal.colorList" :legendList="courseTotal.legendList" :innerText="'单位：门'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></vcolumnarChart>
        </div>
        <div class="chart_name">图12 2021年资源库课程总数与2022年资源库课程总数对比分析</div>
      </div>

      <div class="chart_box" style="margin-top: 120px;">
        <h4>4.3 用户数对比分析</h4>
        <div class="standards_content echartsHeight">
          <vcolumnarChart :isShowTextColor="true" :isExportTextColor="true" :refId="'participatingChart'" :datas='userTotal.dataList' :transverseData="userTotal.transverseData" :colorList="userTotal.colorList" :legendList="userTotal.legendList" :innerText="'单位：人'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></vcolumnarChart>
        </div>
        <div class="chart_name">图13 2021年资源库用户数与2022年资源库用户数对比分析</div>
      </div>

      <div class="chart_box" style="margin-top: 600px;">
        <h4>4.4 访问量对比分析</h4>
        <div class="standards_content echartsHeight">
          <discountChart :isShowTextColor="true" :isExportTextColor="true" :refId="'resourceLibraryChart'" :datas='fangwen.dataList' :transverseData="fangwen.transverseData" :colorList='fangwen.colorList' :legendList='fangwen.legendList' :colorName='1' :innerText="'单位: 次'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></discountChart>
        </div>
        <div class="chart_name">图14 2021年资源库访问量与2022年资源库访问量对比分析</div>
      </div>

      <div class="chart_box" style="margin-top: 220px;">
        <p>附件说明：</p>
        <p>
          为了更好的推进专业培养与产业发展人才对接，“国家职业教育智慧教育平台专业与课程服务中心监测平台”项目组对本专业的人力市场需求进行了深入的市场调研及数据分析，部分分析结果供各专业负责人及专业开设院校参考！
        </p>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import circularChart from '@/components/chart/circularChart.vue'; // 引入圆形图表
import vcolumnarChart from '@/components/chart/vcolumnarChart.vue'; // 引入竖柱状图图表
import tcolumnarChart from '@/components/chart/tcolumnarChart.vue'; // 引入横柱图图表
import discountChart from '@/components/chart/discountChart.vue'; // 引入折线图图表
import waterDropChart from '@/components/chart/waterDropChart.vue'; // 引入水滴图图表
import vcolumnarChartColor from '@/components/chart/vcolumnarChartColor.vue'; // 引入竖柱状图图表

export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    waterDropChart,
    vcolumnarChartColor
  },
  data() {
    return {
      year: '',
      yearAndMonthly: '',
      yearMonthText: '',
      zykStatus: '已立项',
      colorList: ['#3B85FB', '#FD398E', '#8B68F1', '#EE6F5E', '#E0D35F', '#5470C6', '#DE7E4B', '#DE524B'], // 柱状图或折线图的颜色

      header: {
        allHostUnit: '',
        coHostUnit: [],
        endTime: '',
        hostUnit: '',
        startTime: '',
        status: '',
        zykName: '',
        zykNum: ''
      },

      resourceLibrary: { // 图1 资源库注册用户类型分布总体情况
        dataList: [],
        total: 0,
        teacherNum: 0,
        tearcherProportion: 0,
        studentProportion: 0,
        studentNum: 0,
        enterpriseNum: 0,
        socialNum: 0,
        otherNum: 0,
      },

      typeDistribution: { // 图2  当前资源库资源、课程情况
        dataList: [],
        spNumber: 0,
        dhNumber: 0,
        txtxNumber: 0,
        xnfzNumber: 0,
        wbNumber: 0,
        wkNumber: 0,
        ypNumber: 0,
        kjNumber: 0,
        pptNumber: 0,
        fmtNumber: 0,
        qtNumber: 0,
        total: 0,
      },

      usersMonth: { // 图3 用户新增情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        teacherNum: 0,
        studentNum: 0,

      },
      resourcesMonth: { // 图4 资源库各类型素材资源新增情况
        dataList: [],
        transverseData: [],
        legendList: [],
        colorList: [],
        total: 0,
      },
      coursesMonth: { // 图5 课程新增情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0,
      },
      accessMonth: {  // 图6 资源访问情况
        dataList: [],
        transverse: [],
        colorList: [],
        legendList: [],
      },
      visitsMonth: { // 图7 课程访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0,
      },

      userAccessMonth: { // 图8 用户访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0,
      },

      tearcherList: {   // 图9  总访问量最多的教师
        dataList: [],
        transverseData: [],
        colorList: [],
      },

      studentList: {  // 图10 总访问量最多的学生
        dataList: [],
        transverseData: [],
        colorList: [],
      },
      top: {
        realTeacher: 0,
        realStudent: 0,
        noActiveRealTeacher: 0,
        noActiveRealStudent: 0,
        noActiveResource: 0,
        logCount: 0,
        zykRank: 0,
        noStudentAndTearch: 0
      },
      zykTotal: {
        dataList: [],
        colorList: [],
        transverseData: [],
        legendList: []
      },
      fangwen: {
        dataList: [],
        colorList: [],
        transverseData: [],
        legendList: []
      },
      courseTotal: {
        dataList: [],
        colorList: [],
        transverseData: [],
        legendList: [],
        total: null
      },

      userTotal: {
        dataList: [],
        colorList: [],
        transverseData: [],
        legendList: []
      },
      totalNum: 0,
      loading: '', // 是否导出加载中
    };
  },
  created() {
    if (this.$route.query) {
      // this.header = this.$route.query;
      let token = this.$route.query.token;
      sessionStorage.setItem('lrmv2token', token)
      let zykid = this.$route.query.zykid;
      this.dataChange(zykid);
      this.$route.query.zykName = decodeURIComponent(this.$route.query.zykName);
      //const year = this.$route.query.yearOrMonth
      //const monthly = this.$route.query.yearOrMonth
      // const year = this.$route.query.yearOrMonth.substring(0, 4);
      // const monthly = this.$route.query.yearOrMonth.substring(4, this.$route.query.yearOrMonth.length);
      //this.$route.query.startTime = `${year}-${monthly}-${1}`;
      //this.$route.query.endTime = `${year}-${monthly}-${new Date(year, monthly, 0).getDate()}`;
      this.header.zykNum = this.$route.query.zykNum;
      //this.year = `${year}-${monthly}`;
      //this.yearAndMonthly = this.$route.query.yearOrMonth;
      this.yearMonthText = `2022年运行数据分析报告`;

    }
    setTimeout(() => {
      this.getZykStatus();         //   获取资源库状态
      this.fenxi()                 //   年度基本信息
      this.resourceLibraryDom();   //  图1  资源库注册用户类型分布总体情况
      this.typeDistributionDom();  //  图2  当前资源库资源、课程情况
      this.usersMonthDom();        //  图3  用户新增情况(教师,学生)
      this.resourcesMonthDom();   //   图4  素材资源新增情况、
      this.tops()                 //        排名
      this.coursesMonthDom();     //   图5  课程新增
      this.getStudyList()         //   标准化课程数
      this.accessMonthDom();      //   图6  资源访问情况
      this.visitsMonthDom();      //   图7  课程访问情况
      this.userAccessMonthDom();  //   图8  用户访问情况
      this.tearcherTop()          //   图9  教师访问量前十排名
      this.studentTop()          //    图10 学生访问量前十排名

      this.getYearReportByDataAnalysis1()
      this.getYearReportByDataAnalysis2()
      this.getYearReportByDataAnalysis3()
      this.getYearReportByDataAnalysis4()
    }, 2000)
  },
  methods: {
    // 切换专业
    dataChange(e) {
      this.$axios.post(this.$apiurls.major_switch, e, {
        loading: false,
      }).then((res) => {
        if (res.data) {
          sessionStorage.setItem('zykId', e)
          this.reload();
        }
      });
    },
    reload() {  //切换专业刷新视图层
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    },
    // 导出月报
    toImage() {
      this.loading = this.$loading({
        lock: true,
        text: '正在导出中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      this.$axios.post(this.$apiurls.exportMonthReport, {
        courseName: '',
        isAll: false,
        month: this.yearAndMonthly,
        reportType: 0,
        zykId: sessionStorage.getItem('zykId'),
        zykName: this.header.zykName,
        zykNum: this.header.zykNum,
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          window.open(res.data);
          this.loading.close();
        }
      }).catch(() => {
        this.loading.close();
      });
    },

    // 获取资源库状态
    getZykStatus() {
      this.$axios.post(this.$apiurls.report_monthly_getZykStatus, sessionStorage.getItem('zykId'), {
        loading: false,
      }).then((res) => {
        if (res) {
          this.zykStatus = res.data;
        }
      });
    },

    // 年度基本信息
    fenxi() {
      this.$axios.post(this.$apiurls.report_yaer_getZykInformationVo, {
        loading: false
      }).then((res) => {
        this.header.zykName = res.data.zykName
        this.header.coHostUnit = res.data.coHostUnit
        this.header.hostUnit = res.data.hostUnit
        this.header.endTime = res.data.endTime
        this.header.startTime = res.data.startTime
        this.header.status = res.data.status
        this.header.allHostUnit = res.data.allHostUnit.replaceAll(',', '，');
      })
    },
    // 图1 资源库注册用户类型分布总体情况
    resourceLibraryDom() {
      this.$axios.post(this.$apiurls.report_monthly_resourceLibrary, {
        loading: false,
      }).then((res) => {

        if (res) {
          const arrList = [];
          arrList.push({
            name: '教师',
            value: res.data.teacherNum,
          }, {
            name: '学生',
            value: res.data.studentNum,
          });
          this.resourceLibrary.total = res.data.teacherNum + res.data.studentNum;
          this.resourceLibrary.teacherNum = res.data.teacherNum;
          this.resourceLibrary.studentNum = res.data.studentNum;
          this.resourceLibrary.tearcherProportion = ((res.data.teacherNum / this.resourceLibrary.total) * 100).toFixed(2) + '%'
          this.resourceLibrary.studentProportion = ((res.data.studentNum / this.resourceLibrary.total) * 100).toFixed(2) + '%'
          this.resourceLibrary.dataList = arrList;
        }
      });
    },

    // 图2 当前资源库资源、课程情况
    typeDistributionDom() {
      this.$axios.post(this.$apiurls.report_year_getStatResourceDataEntity, 1, {
        loading: false,
      }).then((res) => {
        if (res) {
          const arrList = [];
          arrList.push({
            name: '视频类',
            value: res.data.videoNum,
          }, {
            name: '动画类',
            value: res.data.animationNum,
          }, {
            name: '图形图像类',
            value: res.data.graphicImageNum,
          }, {
            name: '虚拟仿真类',
            value: res.data.virtualSimulationNum,
          }, {
            name: '文本类',
            value: res.data.textNum,
          }, {
            name: '微课类',
            value: res.data.smallCourseNum,
          }, {
            name: '音频类',
            value: res.data.shenyangNum,
          }, {
            name: 'ppt和富媒体等',
            value: res.data.pptNum + res.data.coursewareNum + res.data.mediaNum,
          }, {
            name: '其他',
            value: res.data.otherNum,
          });
          this.typeDistribution.spNumber = res.data.videoNum;
          this.typeDistribution.dhNumber = res.data.animationNum;
          this.typeDistribution.txtxNumber = res.data.graphicImageNum;
          this.typeDistribution.xnfzNumber = res.data.virtualSimulationNum;
          this.typeDistribution.wbNumber = res.data.textNum;
          this.typeDistribution.wkNumber = res.data.smallCourseNum;
          this.typeDistribution.ypNumber = res.data.shenyangNum;
          this.typeDistribution.kjNumber = res.data.coursewareNum;
          this.typeDistribution.pptNumber = res.data.pptNum;
          this.typeDistribution.fmtNumber = res.data.mediaNum;
          this.typeDistribution.qtNumber = res.data.otherNum;
          this.typeDistribution.total = res.data.total;
          this.typeDistribution.dataList = arrList;
        }
      });
    },

    // 图3 用户新增情况
    usersMonthDom() {
      this.$axios.post(this.$apiurls.report_year_getYearhZykAdd, 1, {
        loading: false,
      }).then((res) => {
        if (res) {
          const arrList = []
          for (let i = 0; i < res.data.length; i++) {
            arrList.push(res.data[i].value)
          }

          let teacherNum = 0;
          let studentNum = 0;
          // 新增教师的数量
          let teacherArray = res.data[0].value
          for (let i = 0; i <= teacherArray.length - 1; i++) {
            teacherNum += parseFloat(teacherArray[i])
          }

          // 新增学生的数量
          let studentArray = res.data[1].value
          for (let i = 0; i <= studentArray.length - 1; i++) {
            studentNum += parseFloat(studentArray[i])
          }

          this.usersMonth.dataList = arrList;
          this.usersMonth.transverseData = res.data[0].name;
          this.usersMonth.legendList = ['教师', '学生'];
          this.usersMonth.colorList = this.colorList;
          this.usersMonth.teacherNum = teacherNum;
          this.usersMonth.studentNum = studentNum;
          this.usersMonth.total = teacherNum + studentNum

        }
      });
    },

    // 图4 素材资源新增情况
    resourcesMonthDom() {
      this.$axios.post(this.$apiurls.report_year_getYearhZykAdd, 9, {
        loading: false,
      }).then((res) => {

        let total = 0
        let arrList = []
        let transverseData = []
        let newArray = res.data[0]
        for (let i = 0; i <= newArray.name.length - 1; i++) {
          transverseData.push(newArray.name[i])
        }
        for (let i = 0; i <= newArray.value.length - 1; i++) {
          total += parseFloat(newArray.value[i])
          arrList.push(newArray.value[i])
        }
        this.resourcesMonth.dataList = arrList
        this.resourcesMonth.transverseData = transverseData
        this.resourcesMonth.total = total
        this.resourcesMonth.colorList = this.colorList
        this.resourcesMonth.legendList = ['新增资源']
      });
    },
    // 排名
    tops() {
      this.$axios.post(this.$apiurls.report_yaer_getZykRankYear, {
        loading: false
      }).then((res) => {
        this.top.realStudent = res.data.realStudent
        this.top.realTeacher = res.data.realTeacher
        this.top.noActiveRealStudent = res.data.noActiveRealStudent
        this.top.noActiveRealTeacher = res.data.noActiveRealTeacher
        this.top.noStudentAndTearch = res.data.noActiveRealStudent + res.data.realTeacher
        this.top.noActiveResource = res.data.noActiveResource
        this.top.logCount = res.data.logCount
        this.top.zykRank = res.data.zykRank
      })
    },
    // 标注化课程数
    getStudyList() {
      this.$axios.post(this.$apiurls.report_year_getYearStatStandardcourseaccessList, {
        loading: false
      }).then((res) => {
        this.totalNum = res.data
      })
    },

    // 图5 课程新增情况
    coursesMonthDom() {
      this.$axios.post(this.$apiurls.report_year_getYearhZykAdd, 3, {
        loading: false,
      }).then((res) => {
        let arrList = []
        let transverse = []
        let total = 0
        let newArray = res.data[0]
        for (let i = 0; i <= newArray.name.length - 1; i++) {
          transverse.push(newArray.name[i])
        }
        for (let i = 0; i <= newArray.value.length - 1; i++) {
          total += parseFloat(newArray.value[i])
          arrList.push(newArray.value[i])
        }

        this.coursesMonth.colorList = this.colorList
        this.coursesMonth.transverseData = transverse
        this.coursesMonth.dataList = arrList
        this.coursesMonth.total = total
        this.coursesMonth.legendList = ['新增课程']
      });
    },

    // 图6 资源访问情况
    accessMonthDom() {
      this.$axios.post(this.$apiurls.report_year_getYearhZykAdd, 4, {
        loading: false,
      }).then((res) => {
        let totalArray = res.data[0].value
        let transverse = []
        let total = 0
        let arrList = []
        for (let i = 0; i <= totalArray.length - 1; i++) {
          total += parseFloat(totalArray[i])
        }
        for (let i = 0; i <= res.data.length - 1; i++) {
          transverse.push(res.data[i].name)
          arrList.push(res.data[i].value)
        }
        this.accessMonth.dataList = arrList;
        this.accessMonth.transverseData = res.data[0].name;
        this.accessMonth.legendList = ['资源访问'];
        this.accessMonth.colorList = this.colorList;
        this.accessMonth.total = total;
      });
    },

    // 图7 课程访问情况
    visitsMonthDom() {
      this.$axios.post(this.$apiurls.report_year_getYearhZykAdd, 5, {
        loading: false,
      }).then((res) => {

        let nameArray = res.data[0].name
        let valueArray = res.data[0].value
        let total = 0
        for (let i = 0; i <= valueArray.length - 1; i++) {
          total += parseFloat(valueArray[i])
        }
        this.visitsMonth.dataList = valueArray;
        this.visitsMonth.transverseData = nameArray;
        this.visitsMonth.legendList = ['课程访问'];
        this.visitsMonth.colorList = this.colorList;
        this.visitsMonth.total = total;
      });
    },


    //图8  用户访问情况
    userAccessMonthDom() {
      this.$axios.post(this.$apiurls.report_year_getYearhZykAdd, 7, {
        loading: false
      }).then((res => {
        console.log(res.data, 'asasas');
        let total = 0
        let arrList = []
        for (let i = 0; i < res.data.length; i++) {
          arrList.push(res.data[i].value)
        }
        let valArray = res.data.map(item => item.value)
        valArray[0].concat(valArray[1], valArray[2], valArray[3]).forEach(item => total += parseFloat(item))
        this.userAccessMonth.total = total
        this.userAccessMonth.dataList = arrList
        this.userAccessMonth.transverseData = res.data[0].name
        this.userAccessMonth.colorList = this.colorList
        this.userAccessMonth.legendList = ['教师行为', '学生行为', '社会学习者行为', '企业用户行为']
      }))
    },

    // 图9 总访问量较多的教师（前十）
    tearcherTop() {
      this.$axios.post(this.$apiurls.report_year_getStatLittletenEntityListByYearReport, { statType: 33, limitNum: 10 }, {
        loading: false
      }).then((res) => {
        this.tearcherList.dataList = res.data
        this.tearcherList.colorList = this.colorList
      })
    },

    studentTop() {
      this.$axios.post(this.$apiurls.report_year_getStatLittletenEntityListByYearReport, { statType: 34, limitNum: 10 }, {
        loading: false
      }).then((res) => {
        this.studentList.dataList = res.data
        this.studentList.colorList = this.colorList
      })
    },


    // 年报-年份数据对比分析 (资源总数对比分析)
    getYearReportByDataAnalysis1() {
      this.$axios.post(this.$apiurls.getYearReportByDataAnalysis, { type: 1 }, {
        loading: false
      }).then((res) => {
        this.zykTotal.dataList = res.data.dataList[0]
        this.zykTotal.colorList = this.colorList
        this.zykTotal.legendList = res.data.transverseData
        this.zykTotal.transverseData = res.data.legendList
      })
    },

    // 年报-年份数据对比分析 (课程总数对比分析)
    getYearReportByDataAnalysis2() {
      this.$axios.post(this.$apiurls.getYearReportByDataAnalysis, { type: 2 }, {
        loading: false
      }).then((res) => {
        this.courseTotal.dataList = res.data.dataList
        this.courseTotal.colorList = this.colorList
        this.courseTotal.legendList = res.data.transverseData
        this.courseTotal.transverseData = res.data.legendList

        this.courseTotal.total = res.data.dataList[0][1] + res.data.dataList[1][1]
      })
    },
    // 年报-年份数据对比分析 (用户数对比分析)
    getYearReportByDataAnalysis3() {
      this.$axios.post(this.$apiurls.getYearReportByDataAnalysis, { type: 3 }, {
        loading: false
      }).then((res) => {
        this.userTotal.dataList = res.data.dataList
        this.userTotal.colorList = this.colorList
        this.userTotal.legendList = res.data.legendList
        this.userTotal.transverseData = res.data.transverseData
      })
    },

    // 年报-年份数据对比分析 (访问量对比分析)
    getYearReportByDataAnalysis4() {
      this.$axios.post(this.$apiurls.getYearReportByDataAnalysis, { type: 4 }, {
        loading: false
      }).then((res) => {
        this.fangwen.dataList = res.data.dataList
        this.fangwen.colorList = this.colorList
        this.fangwen.legendList = res.data.transverseData
        this.fangwen.transverseData = res.data.legendList
      })
    },

    // 进度条上的百分比值转化
    teacherFormat() {
      return `${this.waterDrop.teacherNum}%`;
    },
    studentFormat() {
      return `${this.waterDrop.studentNum}%`;
    },
    resourceFormat() {
      return `${this.waterDrop.resourceNum}%`;
    },
    lastresourceFormat() {
      return `${this.waterDrop.lastresourceNum}%`;
    },
    majorteacherFormat() {
      return `${this.waterDrop.majorteacherNum}%`;
    },
    majorstudentFormat() {
      return `${this.waterDrop.majorstudentNum}%`;
    },
    unitteacherFormat() {
      return `${this.waterDrop.unitteacherNum}%`;
    },
    unitstudentFormat() {
      return `${this.waterDrop.unitstudentNum}%`;
    },
  },
};
</script>

<style scoped>
.analysisReport {
  width: 100%;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  width: 80%;
  margin: 0px auto;
  height: 16440px !important;
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
}

.header_titles h1 {
  font-size: 40px;
  font-weight: bold;
  color: #1d244e;
  line-height: 51px;
  margin-top: 100px;
}

.header_titles .monthly {
  font-size: 18px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 40px 0px;
}
.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 25px;
}

.number_time p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  margin-top: 8px;
}
.number_time p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.division {
  width: 100%;
  height: 50px;
  position: relative;
  clear: both;
  margin: 50px 0px;
}
.division span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background: #fff;
  font-weight: bold;
  color: #1d244e;
  font-size: 40px;
  padding: 0px 50px;
  line-height: 30px;
}

.chart_box {
  width: 100%;
  height: auto;
  margin-bottom: 60px;
  clear: both;
}

.chart_box h4 {
  font-weight: 700;
  font-size: 35px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 100px;
}
.chart_box p {
  font-size: 34px;
  text-indent: 2em;
  line-height: 60px;
  color: #707f9d;
}

.chart_box .echartsHeight,
.layout,
.speed {
  width: 80%;
  height: calc(100vw / 1080 * 300);
  height: 400px;
  margin: 50px auto 40px;
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 17px;
  color: #707f9d;
  line-height: 28px;
  margin: 20px auto;
}

.speed .el-col {
  margin-bottom: 15px;
}

.speed .el-col div {
  height: 40px;
  display: flex;
  align-items: center;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 30px;
  color: #707f9d;
  clear: both;
}

.chart_box .notes {
  margin: 35px;
  line-height: 25px;
  font-size: 17px;
  color: #707f9d;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  position: absolute;
  right: 10px;
  top: 10px;
}

.center {
  text-align: center;
}
.divorced {
  margin-top: 40px;
}

::v-deep .el-progress-bar__innerText {
  color: #000;
}
</style>

<style>
::-webkit-scrollbar {
  width: 0px !important;
  height: 14px;
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important;
  border-radius: 3px;
}

.biaoge {
  width: 95%;
  height: 390px;
  margin: 40px auto 0px;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 50px;
  color: #707f9d;
  font-size: 30px;
  line-height: 50px;
}

.course tr:nth-child(2n) {
  background: rgba(11, 201, 212, 0.2);
  /* background: #fff; */
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: rgb(73, 187, 233);

  /* background: #7ed2ff; */
  color: #566178;
}

.course tr:first-child {
  background: rgb(88, 136, 248);

  /* background: #66adff; */
  color: #fff;
}

.chart_box {
  width: 100%;
  margin-bottom: 30px;
}

.chart_box h4 {
  font-weight: 700;
  font-size: 18px;
  color: #1d244e;
  text-indent: 40px;
  line-height: 160px;
}
.chart_box p {
  font-size: 17px;
  text-indent: 40px;
  line-height: 28px;
  color: #707f9d;
  margin-top: 30px;
}

.chart_box .echartsHeight {
  width: 80%;
  height: 380px;
  margin: 0px auto;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 17px;
  color: #707f9d;
}

.chart_box .notes {
  margin: 35px;
  line-height: 25px;
  font-size: 14px;
  color: #707f9d;
}

.creditRanking {
  display: flex;
  justify-content: space-between;
  font-size: 17px;
  text-indent: 40px;
  line-height: 28px;
  color: #707f9d;
}
</style>
